import { ethers } from 'ethers';
import { zeroAddress } from '../../utils/config';

export function buildTokenStakePlan({ requestedAmount, balance, allowance, poolAddress, inviter }) {
    return {
        approval: requestedAmount.gt(allowance)
            ? { method: 'approve', args: [poolAddress, requestedAmount] }
            : null,
        stake: {
            method: 'deposit',
            args: [requestedAmount.gt(balance) ? balance : requestedAmount, inviter || zeroAddress],
        },
    };
}

export function buildTokenWithdrawPlan({ input, decimals, isMax, stakedAmountBigNumber }) {
    const amount = isMax && stakedAmountBigNumber
        ? stakedAmountBigNumber
        : ethers.utils.parseUnits(input, decimals);

    return { method: 'withdraw', args: [amount] };
}

export function buildEmergencyWithdrawPlan() {
    return { method: 'emergencyWithdraw', args: [] };
}

export function buildInviteConfigPlan({ rates, isOpen, fee }) {
    return isOpen
        ? { method: 'setInvitorRewardPercentList', args: [rates] }
        : { method: 'openInviter', args: [rates, { value: ethers.utils.parseEther(`${fee}`) }] };
}

export function buildWhitelistPlan(addresses, isAdd) {
    return { method: 'multiWLs', args: [addresses, isAdd] };
}

export function buildSetEmergencyWithdrawPlan(enabled) {
    return { method: 'setUsercanemergencyWithdraw', args: [enabled] };
}

export function buildStopRewardPlan() {
    return { method: 'stopReward', args: [] };
}

export function buildEmergencyRewardWithdrawPlan(amount) {
    return { method: 'emergencyRewardWithdraw', args: [amount] };
}

export async function runStakeAfterApproval({ approve, stake }) {
    try {
        if (!(await approve())) return false;
        await stake();
        return true;
    } catch (error) {
        return false;
    }
}
